import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../sectionTitle/SectionTitle';

const CallToActionTwo = () => {
    return (
        <div className="edu-newsletter-area newsletter-overlay-to-another">
            <div className="container newsletter-style-5 bg-color-primary">
                <div className="row align-items-center g-5">
                    <div className="col-lg-6">
                        <div className="inner">
                            <SectionTitle
                                classes = "text-start text-white"
                                slogan = "We are here to help"
                                title = "Have a Question?"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-evenly">
                    <div className="cta-btn text-start text-lg-end">
                    <a className="info-btn edu-btn btn-white" href="tel: +1-647-618-5678">
                  <i className="icon-call"></i>  +1-647-618-5678
                </a>
                        </div>
                        <div className="cta-btn text-start text-lg-end">
                            <Link className="edu-btn btn-white" to="/contact-us"><i className="icon-mail-line-2"></i> Email Us<i className="icon-arrow-right-line-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CallToActionTwo;